
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.148 13.801l4.429 1.478a2.23 2.23 0 011.42 1.974V21H3v-3.747a2.224 2.224 0 011.42-1.974l4.423-1.478a4.5 4.5 0 006.305 0zm-2.927-10.8a3.625 3.625 0 013.467 4.36l-.604 3.625a3.246 3.246 0 01-3.085 2.616l-.188-.011a3.246 3.246 0 01-2.898-2.599L8.31 7.361A3.625 3.625 0 0112 3.003z","fill":"#6b6b6b","fill-rule":"evenodd"}})])
          )
        }
      }
    